import { useState, useEffect, useContext } from "react";
import React from "react";
import {
  Box,
  Typography,
  TextField,
  Radio,
  RadioGroup,
  Paper,
  InputAdornment,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
  Button,
  IconButton,
  List,
  ListItem,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as APIAddIcon } from "../../../images/APIAddIcon.svg";
import AddIcon from "@mui/icons-material/Add";
import { ReactComponent as ErrorIcon } from "../../../images/APIErrorIcon.svg";
import { ReactComponent as SuccessIcon } from "../../../images/APISuccessIcon.svg";
import { ReactComponent as RunTestIcon } from "../../../images/RunTestIcon.svg";
import { ReactComponent as GenerateDocumentIcon } from "../../../images/APIGenerateDocumentIcon .svg";
import { ReactComponent as GenerateSampleIcon } from "../../../images/APIGenerateSampleIcon.svg";
import { RemoveCircleOutline } from "@mui/icons-material";
import { ReactComponent as APIResetFormIcon } from "../../../images/APIResetFormIcon.svg";
import { ReactComponent as GenerateButtonIcon } from "../../../images/generateButton.svg";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import { ReactComponent as DownloadIcon } from "../../../images/DownloadIcon.svg";
import APIDocPopup from "./APIDocPopup";
import MessagePopup from "../../popup-components/MessagePopup";
import {
  generateTestCasesForAPI,
  swaggerToPostman,
  manualDetails,
  apiDetailsToYAML,
  APITraceabilityMatrix
} from "../../../services/webServices";
import yaml from "js-yaml";
import { useLocation, useNavigate } from "react-router-dom";
import handleDownloadReport from "../../admin-components/summary-page/summary-page-components/downloadFunctionality";
import { handleProgressBar } from "../../custom-components/ProgressBar/ProgressBarWithAPI";

const ManualDetails = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [apiUrl, setApiUrl] = useState("");
  const [apiType, setApiType] = useState("rest");
  const [method, setMethod] = useState("GET");
  const [headerKey, setHeaderKey] = useState("");
  const [keyValuePairs, setKeyValuePairs] = useState([]);
  const [path, setPath] = useState("");
  const [headerValue, setHeaderValue] = useState("");
  const [description, setDescription] = useState("");
  const [responseType, setResponseType] = useState("");
  const [urlError, setUrlError] = useState("");
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [endpoints, setEndpoints] = useState([
    {
      method: "GET",
      path: "",
      description: "",
      responseType: "",
      queryParams: [],
      formDataParams: [],
      jsonBody: "",
      xmlBody: "",
      bodyType: "none", // ADD THIS
      headers: [],
      // Authorization fields
      authMethod: "none",
      bearerToken: "",
      authUserName: "",
      authPassword: "",
      authKeyName: "",
      authKeyValue: "",
      authAddto: "none",
      auth2Flow: "",
      authClientID: "",
      authClientSecret: "",
      authorizationURL: "",
      tokenURL: "",
      scope: "",
    },
  ]);
  const [headers, setHeaders] = useState([{ key: "", value: "" }]);
  const [authMethod, setAuthMethod] = useState("");
  const [requestTimeout, setRequestTimeout] = useState("");
  const [maxRedirects, setMaxRedirects] = useState("");
  const [followRedirects, setFollowRedirects] = useState(true);
  const [verifySSL, setVerifySSL] = useState(true);
  const [status, setStatus] = useState(null);
  const [WSDLUrl, setWSDLUrl] = useState("");
  const [soapAction, setSoapAction] = useState("");
  const [soapVersion, setSoapVersion] = useState("SOAP 1.1");
  //const [responseType, setResponseType] = useState("");
  const [envelopeTemplate, setEnvelopeTemplate] = useState("");
  const [graphqlEndpoint, setGraphqlEndpoint] = useState("");
  const [graphqlResponseType, setGraphqlResponseType] = useState("");
  const [sampleQuery, setSampleQuery] = useState("");
  const [protocol, setProtocol] = useState("https://");
  const [bearerToken, setBearerToken] = useState("");
  const [authUserName, setAuthUserName] = useState("");
  const [authPassword, setAuthPassword] = useState("");
  const [authKeyName, setAuthKeyName] = useState("");
  const [authKeyValue, setAuthKeyValue] = useState("");
  const [authAddto, setAuthAddto] = useState("");
  const [auth2Flow, setAuth2Flow] = useState("");
  const [authClientID, setAuthClientID] = useState("");
  const [authClientSecret, setAuthClientSecret] = useState("");
  const [authorizationURL, setAuthorizationURL] = useState("");
  const [tokenURL, setTokenURL] = useState("");
  const [scope, setScope] = useState("");
  const [apiDocument, setApiDocument] = useState("");
  const { setLoadingState } = useContext(LoadingModalContext);
  const [successPopup, setSuccessPopup] = useState(false);
  const [endpointFormData, setEndpointFormData] = useState({});

  const addEndpoint = () => {
    const newEndpoint = {
      method: "GET",
      path: "",
      description: "",
      queryParams: [],
      formDataParams: [],
      jsonBody: "",
      xmlBody: "",
      responseType: "",
      headers: [],
      bodyType: "none", // ADD THIS LINE
      // Authorization fields
      authMethod: "none",
      bearerToken: "",
      authUserName: "",
      authPassword: "",
      authKeyName: "",
      authKeyValue: "",
      authAddto: "none",
      auth2Flow: "",
      authClientID: "",
      authClientSecret: "",
      authorizationURL: "",
      tokenURL: "",
      scope: "",
    };

    setEndpoints((prev) => [...prev, newEndpoint]);

    setHeaderKey("");
    setHeaderValue("");
  };

  const getEndpointFormData = (index) => {
    return (
      endpointFormData[index] || {
        queryKey: "",
        queryValue: "",
        formDataKey: "",
        formDataValue: "",
      }
    );
  };

  const updateEndpointFormData = (index, field, value) => {
    setEndpointFormData((prev) => ({
      ...prev,
      [index]: {
        ...getEndpointFormData(index),
        [field]: value,
      },
    }));
  };

  const addHeader = () => {
    setHeaders([...headers, { key: "", value: "" }]);
  };

  useEffect(() => {
    if (
      props.registerHandlers &&
      typeof props.registerHandlers === "function"
    ) {
      props.registerHandlers({
        handleAPIDetailsLoadDemoExample,
      });
    } else {
      console.error("registerHandlers is not a function or not provided");
    }
  }, [props.registerHandlers]);

  const handleAddHeader = (index) => {
    if (headerKey.trim() && headerValue.trim()) {
      setEndpoints((prev) =>
        prev.map((ep, i) =>
          i === index
            ? {
              ...ep,
              headers: [
                ...(ep.headers || []),
                { key: headerKey, value: headerValue },
              ],
            }
            : ep
        )
      );

      setKeyValuePairs([
        ...keyValuePairs,
        { key: headerKey, value: headerValue },
      ]);
      setHeaderKey("");
      setHeaderValue("");
    
    }
  };

  const handleAddQueryParam = (index) => {
    const formData = getEndpointFormData(index);
    if (formData.queryKey.trim() !== "" && formData.queryValue.trim() !== "") {
      // Add the query parameter to the endpoint
      setEndpoints((prev) =>
        prev.map((ep, i) =>
          i === index
            ? {
              ...ep,
              queryParams: [
                ...(ep.queryParams || []),
                { key: formData.queryKey, value: formData.queryValue },
              ],
            }
            : ep
        )
      );

      // Clear the form fields for this specific endpoint
      setEndpointFormData((prev) => ({
        ...prev,
        [index]: {
          ...getEndpointFormData(index),
          queryKey: "",
          queryValue: "",
        },
      }));
    }
  };

  const handleDeleteQueryParam = (paramIndex, endpointIndex) => {
    setEndpoints((prev) =>
      prev.map((ep, i) =>
        i === endpointIndex
          ? {
            ...ep,
            queryParams: ep.queryParams.filter(
              (_, idx) => idx !== paramIndex
            ),
          }
          : ep
      )
    );
  };
  const handleAddFormData = (index) => {
    const formData = getEndpointFormData(index);
    if (
      formData.formDataKey.trim() !== "" &&
      formData.formDataValue.trim() !== ""
    ) {
      // Add the form data parameter to the endpoint
      setEndpoints((prev) =>
        prev.map((ep, i) =>
          i === index
            ? {
              ...ep,
              formDataParams: [
                ...(ep.formDataParams || []),
                { key: formData.formDataKey, value: formData.formDataValue },
              ],
            }
            : ep
        )
      );

      // Clear the form fields for this specific endpoint
      setEndpointFormData((prev) => ({
        ...prev,
        [index]: {
          ...getEndpointFormData(index),
          formDataKey: "",
          formDataValue: "",
        },
      }));
    }
  };

  const handleDeleteFormData = (paramIndex, endpointIndex) => {
    setEndpoints((prev) =>
      prev.map((ep, i) =>
        i === endpointIndex
          ? {
            ...ep,
            formDataParams: ep.formDataParams.filter(
              (_, idx) => idx !== paramIndex
            ),
          }
          : ep
      )
    );
  };

  // const handleAPIDetailsLoadDemoExample = (e) => {
  //   e.stopPropagation();
  //   setApiUrl("cricbuzz-cricket.p.rapidapi.com");
  //   setApiType("rest");
  //   setEndpoints([
  //     {
  //       method: "GET",
  //       path: "mcenter/v1/35878/team/9",
  //       description: "Team Size",
  //       responseType: "JSON",
  //     },
  //   ]);
  //   setHeaderKey("x-rapidapi-host");
  //   setHeaderValue("cricbuzz-cricket.p.rapidapi.com");
  //   setAuthMethod("none");
  //   setRequestTimeout("5000");
  //   setMaxRedirects("3");
  //   setFollowRedirects(false);
  //   setVerifySSL(true);
  // };

  const handleAPIDetailsLoadDemoExample = (e) => {
    e.stopPropagation();

    // Set common API details
    setApiUrl("bookstore.toolsqa.com");
    setApiType("rest");
    setRequestTimeout("5000");
    setMaxRedirects("3");
    setFollowRedirects(false);
    setVerifySSL(true);

    // Set 11 demo endpoints
    setEndpoints([
      {
        method: "POST",
        path: "/Account/v1/Authorized",
        description: "Check if user credentials are valid",
        responseType: "application/json",
        queryParams: [],
        headers: [
          { key: "Content-Type", value: "application/json", isAuthHeader: false }
        ],
        authMethod: "Basic Auth",
        authUserName: "authorization",
        authPassword: "BASE64(username:password)",
        authAddto: "",
        bodyType: "json",
        jsonBody: JSON.stringify({ "userName": "string", "password": "string" }, null, 2)
      },
      // {
      //   method: "POST",
      //   path: "/Account/v1/GenerateToken",
      //   description: "Generate authentication token",
      //   responseType: "application/json",
      //   queryParams: [],
      //   headers: [
      //     { key: "Content-Type", value: "application/json", isAuthHeader: false }
      //   ],
      //   authMethod: "Basic Auth",
      //   authKeyName: "authorization",
      //   authKeyValue: "Basic BASE64(username:password)",
      //   authAddto: "header",
      //   bodyType: "json",
      //   jsonBody: JSON.stringify({ "userName": "string", "password": "string" }, null, 2)
      // },
      {
        method: "POST",
        path: "/Account/v1/User",
        description: "Create a new user",
        responseType: "application/json",
        queryParams: [],
        headers: [
          { key: "Content-Type", value: "application/json", isAuthHeader: false }
        ],
        authMethod: "none",
        authKeyName: "",
        authKeyValue: "",
        authAddto: "",
        bodyType: "json",
        jsonBody: JSON.stringify({
          "userName": "string",
          "password": "string",
          "userId": "GUID"
        }, null, 2)
      },
      {
        method: "GET",
        path: "/Account/v1/User/{UserId}",
        description: "Get user details including books",
        responseType: "application/json",
        queryParams: [],
        headers: [
          { key: "authorization", value: "Bearer YOUR_TOKEN", isAuthHeader: true }
        ],
        authMethod: "Bearer Token",
        authKeyName: "authorization",
        authKeyValue: "Bearer YOUR_TOKEN",
        authAddto: "",
        bodyType: "none"
      },
      {
        method: "GET",
        path: "/BookStore/v1/Books",
        description: "Retrieve list of all books",
        responseType: "application/json",
        queryParams: [],
        headers: [
          { key: "accept", value: "application/json", isAuthHeader: false }
        ],
        authMethod: "none",
        authKeyName: "",
        authKeyValue: "",
        authAddto: "",
        bodyType: "none"
      },
      // {
      //   method: "POST",
      //   path: "/BookStore/v1/Books",
      //   description: "Add book(s) to a user’s collection",
      //   responseType: "application/json",
      //   queryParams: [],
      //   headers: [
      //     { key: "authorization", value: "Bearer YOUR_TOKEN", isAuthHeader: true },
      //     { key: "Content-Type", value: "application/json", isAuthHeader: false }
      //   ],
      //   authMethod: "Bearer Token",
      //   authKeyName: "authorization",
      //   authKeyValue: "Bearer YOUR_TOKEN",
      //   authAddto: "",
      //   bodyType: "json",
      //   jsonBody: JSON.stringify({
      //     "userId": "GUID",
      //     "collectionOfIsbns": [{ "isbn": "string" }]
      //   }, null, 2)
      // },
      {
        method: "DELETE",
        path: "/BookStore/v1/Books",
        description: "Remove book(s) from a user’s collection",
        responseType: "application/json",
        queryParams: [],
        headers: [
          { key: "authorization", value: "Bearer YOUR_TOKEN", isAuthHeader: true },
          { key: "Content-Type", value: "application/json", isAuthHeader: false }
        ],
        authMethod: "Bearer Token",
        authKeyName: "authorization",
        authKeyValue: "YOUR_TOKEN",
        authAddto: "",
        bodyType: "json",
        jsonBody: JSON.stringify({
          "userId": "GUID",
          "isbn": "string"
        }, null, 2)
      },
      {
        method: "GET",
        path: "/Account/v1/User",
        description: "Get list of all users",
        responseType: "application/json",
        queryParams: [],
        headers: [
          { key: "authorization", value: "Basic BASE64(admin:password)", isAuthHeader: true }
        ],
        authMethod: "Basic Auth",
        authKeyName: "authorization",
        authKeyValue: "Basic BASE64(admin:password)",
        authAddto: "header",
        bodyType: "none"
      },
      {
        method: "DELETE",
        path: "/Account/v1/User/{UserId}",
        description: "Delete a user by userId",
        responseType: "application/json",
        queryParams: [],
        headers: [
          { key: "authorization", value: "Basic BASE64(admin:password)", isAuthHeader: true }
        ],
        authMethod: "API Key",
        authKeyName: "authorization",
        authKeyValue: "Bearer BASE64(admin:password)",
        authAddto: "header",
        bodyType: "none"
      },
      // {
      //   method: "PUT",
      //   path: "/Account/v1/User/{UserId}",
      //   description: "Update a user’s password",
      //   responseType: "application/json",
      //   queryParams: [],
      //   headers: [
      //     { key: "authorization", value: "Basic BASE64(username:oldpassword)", isAuthHeader: true },
      //     { key: "Content-Type", value: "application/json", isAuthHeader: false }
      //   ],
      //   authMethod: "Basic Auth",
      //   authKeyName: "authorization",
      //   authKeyValue: "Basic BASE64(username:oldpassword)",
      //   authAddto: "header",
      //   bodyType: "json",
      //   jsonBody: JSON.stringify({
      //     "userName": "string",
      //     "password": "string"
      //   }, null, 2)
      // }
    ]);


    // Reset form data states
    setHeaderKey("");
    setHeaderValue("");
    setAuthMethod("API Key");

    // Clear any existing form data for endpoints
    // This assumes you have a function to clear endpoint form data
    // You might need to adjust this based on your form data management

    setEndpointFormData({});


    // Optional: Show a success message or notification

  };


  const generateAPIDocumentation = async () => {
    //setLoading(true);
    try {
      const authorizationCommon = {};
      const manualDetailsData = {
        apiUrl: apiUrl,
        apiType: apiType,
        // method: method,
        // keyValuePairs: keyValuePairs,
        endpoints: endpoints,
        //  headers: headers,
        //authMethod: authMethod,
        // authorizationCommon: authorizationCommon,
        requestTimeout: requestTimeout,
        maxRedirects: maxRedirects,
        followRedirects: followRedirects,
        verifySSL: verifySSL,

        protocol: protocol,
      };
      const response = await apiDetailsToYAML(manualDetailsData);
      // const response = await manualDetails(manualDetailsData);
   

      setApiDocument(response.data);
      if (response.data) {
        setSuccessPopup(true);
      }
    } catch (error) {
      console.error("Error generating test cases:", error);
      setPopupMessage("Something went wrong while generating the API documentation.");
      setPopupOpen(true);
    } finally {
      //setLoading(false);
    }
  };

  const handleCloseSuccessPopup = () => {
    setSuccessPopup(false);
  };
  const validateUrl = (url) => {
    if (!url) return "URL is required";

    const cleanUrl = url.replace(/^https?:\/\//, '');

    // Check if URL has a domain extension
    const domainExtensionPattern = /\.[a-zA-Z]{2,}$/;

    if (!domainExtensionPattern.test(cleanUrl)) {
      return "URL must contain a valid domain extension (e.g., .com, .org, .net)";
    }



    //  Check basic URL structure
    const basicUrlPattern = /^[a-zA-Z0-9][a-zA-Z0-9\-\.]*[a-zA-Z0-9]\.[a-zA-Z]{2,}(\/.*)?$/;
    if (!basicUrlPattern.test(cleanUrl)) {
      return "Please enter a valid URL format";
    }

    return "";
  };


  function flattenPostmanItems(items) {
    const flat = [];

    function recurse(subItems) {
      subItems.forEach(item => {
        if (item.request) {
          flat.push(item); // it's a request
        } else if (item.item && item.item.length > 0) {
          recurse(item.item); // it's a folder
        }
      });
    }

    recurse(items);
    return flat;
  }

  const generateTestCases = async () => {
    let tcCounter = 1; // Ensure tcCounter is initialized

    let progressHandler;
    progressHandler = handleProgressBar({ setLoadingState, totalDurationMs: 195000 });
    try {
     
      const finalArray = [];
      let traceabilityMatrix = null;
      progressHandler.start(`Generating Test Cases for API Endpoints`);

      const responseData = await swaggerToPostman(apiDocument.data);

      if (responseData.data.item) {
        const flattenedItems = flattenPostmanItems(responseData.data.item);
       

        const promises = flattenedItems.map(async(item, index) => {
        

          try {
            const testcasesresponse = await generateTestCasesForAPI(item);

            if (testcasesresponse.data && testcasesresponse.data?.testcases) {
            
              return testcasesresponse.data.testcases;
            }
          } catch (error) {
            console.log(
              error?.response?.data?.error || error.message,
              "Error processing swagger item:", index + 1
            );
            // setPopupMessage(`Error processing item ${i + 1}: ${error?.response?.data?.error || error.message}`);
            // setPopupOpen(true);
          }
          return []; // Return an empty array if there's an error
        }

        );
     

        
      const results = await Promise.allSettled(promises);
     
      // Flatten results and assign Test Case IDs safely
      for (const result of results) {
        if (result.status === "fulfilled" && Array.isArray(result.value)) {
          const updated = result.value.map((testcase) => {
            const isFunctional = testcase.Category?.toLowerCase() === "functional testing";
            const subCategory = testcase["Sub-Category"]?.toLowerCase() || "";

            let prefix = isFunctional ? "TCD_FT" : "TCD_NFT";
            let shortCode = "";

            if (subCategory.includes("positive")) shortCode = "POS";
            else if (subCategory.includes("negative")) shortCode = "NEG";
            else if (subCategory.includes("boundary")) shortCode = "BOUND";
            else if (subCategory.includes("error")) shortCode = "ERR";
            else if (subCategory.includes("security")) shortCode = "SEC";
            else if (subCategory.includes("performance")) shortCode = "PERF";

            const padded = String(tcCounter).padStart(2, "0");
            const id = `${prefix}_${padded}_${shortCode}`;
            tcCounter++;

            return {
              ...testcase,
              "Test Case ID": id,
            };
          });

          finalArray.push(...updated);
        }
      }
    
     

        const filteredTestCases = finalArray.map((testcase) => ({
          "Test Case ID": testcase["Test Case ID"],
          "API Endpoint": testcase["API Endpoint"],
          "Method": testcase["Method"],
          "Test Description": testcase["Test Description"],
          "Category": testcase["Category"],
        }));

        try {
          progressHandler.updateMessage("Generating Traceability Matrix");
          const response = await APITraceabilityMatrix(filteredTestCases);
          if (response.data !== null) {
            traceabilityMatrix = response.data;
          }
        } catch (error) {
          console.log(
            error?.response?.data?.error || error.message,
            "Error generating traceability matrix"
          );
          setPopupMessage("Error generating traceability matrix");
          setPopupOpen(true);
        }

        await progressHandler.finishAndClose();

        navigate("/dashboard/api-testing/manual", {
          state: {
            ...location.state,
            generateTestCasesData: finalArray,
            apiDocData: apiDocument || null,
            button: "configureAPIDefinition",
            traceabilityMatrix: traceabilityMatrix,
          },
        });
      }
    } catch (error) {
      console.error("Error generating test cases:", error);
      setLoadingState({ open: false, message: "", progress: null });
      setPopupMessage("Something went wrong while generating the test cases.");
      setPopupOpen(true);
    } finally {
      if (progressHandler) {
        progressHandler.stop();
      }
      setLoadingState({ open: false, message: "", progress: null });
    }
  };


  const handleRemove = (index) => {
    setEndpoints((prev) => prev.filter((_, i) => i !== index));
  };


  const handleResetForm = () => {
    setApiUrl("");
    setApiType("rest");
    setMethod("GET");
    setHeaderKey("");
    setKeyValuePairs([]);
    setPath("");
    setHeaderValue("");
    setDescription("");
    setResponseType("");
    setEndpoints([
      {
        method: "GET",
        path: "",
        description: "",
        responseType: "",
        queryParams: [],
        formDataParams: [],
        jsonBody: "",
        xmlBody: "",
        bodyType: "none",
        headers: [],
        // Authorization fields
        authMethod: "none",
        bearerToken: "",
        authUserName: "",
        authPassword: "",
        authKeyName: "",
        authKeyValue: "",
        authAddto: "none",
        auth2Flow: "",
        authClientID: "",
        authClientSecret: "",
        authorizationURL: "",
        tokenURL: "",
        scope: "",
      },
    ]);
    setHeaders([{ key: "", value: "" }]);
    setAuthMethod("");
    setRequestTimeout("");
    setMaxRedirects("");
    setFollowRedirects();
    setVerifySSL();
    setWSDLUrl("");
    setSoapAction("");
    setSoapVersion("SOAP 1.1");
    setEnvelopeTemplate("");
    setGraphqlEndpoint("");
    setGraphqlResponseType("");
    setSampleQuery("");
    setProtocol("https://");
    setBearerToken("");
    setAuthUserName("");
    setAuthPassword("");
    setAuthKeyName("");
    setAuthKeyValue("");
    setAuthAddto("");
    setAuth2Flow("");
    setAuthClientID("");
    setAuthClientSecret("");
    setAuthorizationURL("");
    setTokenURL("");
    setScope("");
    setEndpointFormData({});
  };

  const handleDownloadAPIDocument = (apiDocument) => {
    if (!apiDocument) return;

    try {
      const yamlString = yaml.dump(apiDocument.data);
      const blob = new Blob([yamlString], { type: "text/yaml" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "openapi-document.yaml";
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error converting OpenAPI document to YAML:", error);
      //setPopupMessage("Error converting OpenAPI document to YAML.");
    }
  };

  const handleDeleteHeader = (headerIndex, endpointIndex) => {
    const headerToDelete = endpoints[endpointIndex].headers[headerIndex];
    if (headerToDelete.isAuthHeader) {
      return;
    }
    setEndpoints((prev) =>
      prev.map((ep, i) =>
        i === endpointIndex
          ? {
            ...ep,
            headers: ep.headers.filter((_, idx) => idx !== headerIndex),
          }
          : ep
      )
    );

    setKeyValuePairs((prev) =>
      prev.filter(
        (header) =>
          !(
            header.key === headerToDelete.key &&
            header.value === headerToDelete.value
          )
      )
    );
  };

  return (
    <Box sx={{ p: 2, width: "95%", height: "400px", overflowY: "auto" }}>
        <Typography variant="subtitle1" sx={{color:"#808080", mb:3}}>Configure your API manually for complete control over test generation parameters</Typography>
      <TextField
        fullWidth
        required
        variant="outlined"
        placeholder="Enter URL"
        label="API URL"
        value={apiUrl}
        onChange={(e) => setApiUrl(e.target.value)}
        onBlur={(e) => setUrlError(validateUrl(e.target.value))}
        error={!!urlError}
        helperText={urlError}
        sx={{ mb: 3 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Select
                value={protocol}
                onChange={(e) => setProtocol(e.target.value)}
                //variant="text" // Use outlined for full background
                variant="standard" // No visible outline
                disableUnderline
                sx={{
                  minWidth: 85,
                  mr: 1,
                  bgcolor: "#F4F2EC",
                  height: "40px",

                  "& .MuiSelect-select": {
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "8px", // Curved corners
                    px: 0.8,
                    py: 0.5,
                  },
                }}
              >
                <MenuItem value="http://">http://</MenuItem>
                <MenuItem value="https://">https://</MenuItem>
              </Select>
            </InputAdornment>
          ),
        }}
      />
      {/* API Type Selection */}
      <Typography
        variant="subtitle1"
        fontWeight={"bold"}
        sx={{ mb: 1, fontSize: "" }}
      >
        API Type
      </Typography>
      <Box
        sx={{
          display: "flex",
          // Scroll if needed
          alignItems: "center",
          mb: 2,
          justifyContent: "center",
          width: "100%",
          //bgcolor: "#F4F2EC",
        }}
      >
        <RadioGroup
          row
          value={apiType}
          onChange={(e) => setApiType(e.target.value)}
          sx={{ display: "flex", gap: 2 }}
        >
          {[
            {
              value: "rest",
              label: "Rest",
              description: "Resource-based HTTP API",
              disabled: false
            },
            { value: "soap", label: "SOAP", description: "XML-based protocol", disabled: true },
            {
              value: "graphql",
              label: "GraphQL",
              description: "Query language for APIs",
              disabled: true
            },
          ].map((option) => (
            <Paper
              key={option.value}
              sx={{
                border: `1px solid ${apiType === option.value ? "#49A3FF" : "#E0E0E0"
                  }`,
                borderRadius: 2,
                p: 1,
                minWidth: "145px",
                maxWidth: "20px",

                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: option.disabled ? 0.5 : 1,

                //   boxShadow: apiType === option.value ? "0px 0px 5px #49A3FF" : "none",
              }}
              onClick={() => {
                if (!option.disabled) setApiType(option.value)
              }}
            >
              <FormControlLabel
                value={option.value}
                control={<Radio disabled={option.disabled} />}
                label={
                  <Box>
                    <Typography sx={{ fontSize: "14px" }}>
                      {option.label}
                    </Typography>
                    <Typography sx={{ fontSize: "12px", color: "#757575" }}>
                      {option.description}
                    </Typography>
                  </Box>
                }
                sx={{ m: 0 }}
              />
            </Paper>
          ))}
        </RadioGroup>
      </Box>
      {apiType === "rest" && (
        <Box sx={{ p: 2 }}>
          <Typography
            variant="subtitle1"
            fontWeight={"bold"}
            sx={{ fontSize: "" }}
          >
            REST Endpoints
          </Typography>
          <Typography fontSize={11}>
            Define the endpoints for your REST API. Each endpoint should have a
            path, HTTP method, and optional description
          </Typography>
          {endpoints.map((endpoint, index) => (
            <Box
              key={index}
              sx={{
                p: 2,
                border: "1px",
                borderRadius: 2,
                backgroundColor: "#49A3FF0F",
                mt: 2,
                position: "relative",
              }}
            >
              <IconButton
                size="small"
                onClick={() => handleRemove(index)}
                sx={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  color: "#555",
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
              <Typography
                variant="subtitle1"
                fontWeight={"bold"}
                sx={{ fontSize: "" }}
              >Endpoint - {index + 1}</Typography>

              <Box sx={{ display: "flex", alignItems: "center", gap: 2, }}>


                <FormControl sx={{ width: "40%", mt: 1.8 }}>
                  <InputLabel>HTTP Method *</InputLabel>
                  <Select
                    required
                    value={endpoint.method}
                    onChange={(e) =>
                      setEndpoints((prev) =>
                        prev.map((ep, i) =>
                          i === index ? { ...ep, method: e.target.value } : ep
                        )
                      )
                    }
                    label="HTTP Method"
                  >
                    <MenuItem value="GET">GET</MenuItem>
                    <MenuItem value="POST">POST</MenuItem>
                    <MenuItem value="PUT">PUT</MenuItem>
                    <MenuItem value="DELETE">DELETE</MenuItem>
                  </Select>
                </FormControl>
                <FormControl sx={{ mt: 1.8, width: "100%" }}>
                  <TextField
                    required
                    //sx={{ width: "340px", }}
                    fullWidth
                    label="Enter Path"
                    placeholder="Enter Path"
                    value={endpoint.path}
                    onChange={(e) => {
                      const newPath = e.target.value;
                      setEndpoints((prev) =>
                        prev.map((ep, i) =>
                          i === index ? { ...ep, path: newPath } : ep
                        )
                      );
                    }}
                  />
                </FormControl>
              </Box>
              <TextField
                fullWidth
                placeholder="Enter Description"
                label="Description"
                value={endpoint.description}
                onChange={(e) =>
                  setEndpoints((prev) =>
                    prev.map((ep, i) =>
                      i === index ? { ...ep, description: e.target.value } : ep
                    )
                  )
                }
                sx={{ my: 2 }}
              />

              {/* Query Parameters */}
              <Typography
                variant="subtitle1"
                sx={{ mt: 0, mb: 1, fontSize: "14px" }}
              >
                Query Parameters
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: "100%" }}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    // sx={{ width: "230px" }}
                    fullWidth
                    label="Key"
                    placeholder="Enter Key"
                    value={getEndpointFormData(index).queryKey}
                    onChange={(e) =>
                      updateEndpointFormData(index, "queryKey", e.target.value)
                    }
                  />
                </FormControl>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    //sx={{ width: "210px" }}
                    fullWidth
                    label="Value"
                    placeholder="Enter Value"
                    value={getEndpointFormData(index).queryValue}
                    onChange={(e) =>
                      updateEndpointFormData(index, "queryValue", e.target.value)
                    }
                  />
                </FormControl>
                <IconButton
                  onClick={() => handleAddQueryParam(index)}
                  size="small"
                  sx={{ alignSelf: "flex-end", mb: 1 }}
                  disabled={
                    getEndpointFormData(index).queryKey.trim() === "" ||
                    getEndpointFormData(index).queryValue.trim() === ""
                  }
                >
                  <APIAddIcon />
                </IconButton>
              </Box>

              {/* Display Query Parameters */}
              {endpoint.queryParams && endpoint.queryParams.length > 0 && (
                <List>
                  {endpoint.queryParams.map((param, paramIndex) => (
                    <ListItem
                      key={paramIndex}
                      sx={{
                        bgcolor: "#f8f8f8",
                        borderRadius: 2,
                        my: 1,
                        px: 2,
                        py: 0.5,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={5}>
                          <Typography
                            variant="body1"
                            sx={{
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                              overflowWrap: "anywhere",
                            }}
                          >
                            {paramIndex + 1}. {param.key}
                            {param.isAuthParam}
                          </Typography>
                        </Grid>
                        <Grid item xs={5}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "14px",
                              color: "#838383",
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                              overflowWrap: "anywhere",
                            }}
                          >
                            {/* {param.value} */}
                            {param.isAuthParam ? param.value : param.value}
                          </Typography>
                        </Grid>
                        <Grid item xs={2} sx={{ textAlign: "right" }}>
                          <IconButton
                            onClick={() =>
                              handleDeleteQueryParam(paramIndex, index)

                            }
                            color="error"
                            disabled={param.isAuthParam}
                          >
                            <RemoveCircleOutline />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </ListItem>
                  ))}
                </List>
              )}
              {/* Body Configuration */}
              <Typography
                variant="subtitle1"
                sx={{ mt: 2, mb: 1, fontSize: "14px" }}
              >
                Body
              </Typography>
              <FormControl>
                <RadioGroup
                  row
                  value={endpoint.bodyType || "none"}
                  onChange={(e) => {
                    const value = e.target.value;
                    setEndpoints((prev) =>
                      prev.map((ep, i) =>
                        i === index ? { ...ep, bodyType: value } : ep
                      )
                    );
                  }}
                  sx={{ mb: 2 }}
                >
                  <FormControlLabel
                    value="none"
                    control={<Radio />}
                    label="None"
                    sx={{ "& .MuiTypography-root": { fontSize: "0.850rem" } }}
                  />
                  <FormControlLabel
                    value="formdata"
                    control={<Radio />}
                    label="Form Data"
                    sx={{ "& .MuiTypography-root": { fontSize: "0.850rem" } }}
                  />
                  <FormControlLabel
                    value="json"
                    control={<Radio />}
                    label="JSON"
                    sx={{ "& .MuiTypography-root": { fontSize: "0.850rem" } }}
                  />
                  <FormControlLabel
                    value="xml"
                    control={<Radio />}
                    label="XML"
                    sx={{ "& .MuiTypography-root": { fontSize: "0.850rem" } }}
                  />
                </RadioGroup>
              </FormControl>

              {/* Form Data Body */}
              {(endpoint.bodyType || "none") === "formdata" && (
                <Box sx={{ mt: 1 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <FormControl sx={{ width: "100%" }}>
                      <TextField
                        // sx={{ width: "230px" }}
                        fullWidth
                        label="Field Key"
                        placeholder="Enter Key"
                        value={getEndpointFormData(index).formDataKey}
                        onChange={(e) =>
                          updateEndpointFormData(
                            index,
                            "formDataKey",
                            e.target.value
                          )
                        }
                      />
                    </FormControl>
                    <FormControl sx={{ width: "100%" }}>
                      <TextField
                        //sx={{ width: "210px" }}
                        fullWidth
                        label="Field Value"
                        placeholder="Enter Value"
                        value={getEndpointFormData(index).formDataValue}
                        onChange={(e) =>
                          updateEndpointFormData(
                            index,
                            "formDataValue",
                            e.target.value
                          )
                        }
                      />
                    </FormControl>
                    <IconButton
                      onClick={() => handleAddFormData(index)}
                      size="small"
                      sx={{ alignSelf: "flex-end", mb: 1 }}
                    >
                      <APIAddIcon />
                    </IconButton>
                  </Box>

                  {/* Display Form Data Parameters */}
                  {endpoint.formDataParams &&
                    endpoint.formDataParams.length > 0 && (
                      <List>
                        {endpoint.formDataParams.map((param, formIndex) => (
                          <ListItem
                            key={formIndex}
                            sx={{
                              bgcolor: "#f8f8f8",
                              borderRadius: 2,
                              my: 1,
                              px: 2,
                              py: 0.5,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Grid container alignItems="center" spacing={2}>
                              <Grid item xs={5}>
                                <Typography
                                  variant="body1"
                                  sx={{
                                    wordBreak: "break-word",
                                    whiteSpace: "normal",
                                    overflowWrap: "anywhere",
                                  }}
                                >
                                  {formIndex + 1}. {param.key}
                                </Typography>
                              </Grid>
                              <Grid item xs={5}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontSize: "14px",
                                    color: "#838383",
                                    wordBreak: "break-word",
                                    whiteSpace: "normal",
                                    overflowWrap: "anywhere",
                                  }}
                                >
                                  {param.value}
                                </Typography>
                              </Grid>
                              <Grid item xs={2} sx={{ textAlign: "right" }}>
                                <IconButton
                                  onClick={() =>
                                    handleDeleteFormData(formIndex, index)
                                  }
                                  color="error"
                                >
                                  <RemoveCircleOutline />
                                </IconButton>
                              </Grid>
                            </Grid>
                          </ListItem>
                        ))}
                      </List>
                    )}
                </Box>
              )}
              {(endpoint.bodyType || "none") === "json" && (
                <TextField
                  fullWidth
                  multiline
                  minRows={4}
                  label="JSON Body"
                  placeholder="Enter JSON data..."
                  value={endpoint.jsonBody || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setEndpoints((prev) =>
                      prev.map((ep, i) =>
                        i === index ? { ...ep, jsonBody: value } : ep
                      )
                    );
                  }}
                  sx={{ mt: 1 }}
                />
              )}

              {/* XML Body */}
              {(endpoint.bodyType || "none") === "xml" && (
                <TextField
                  fullWidth
                  multiline
                  minRows={4}
                  label="XML Body"
                  placeholder="Enter XML data..."
                  value={endpoint.xmlBody || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setEndpoints((prev) =>
                      prev.map((ep, i) =>
                        i === index ? { ...ep, xmlBody: value } : ep
                      )
                    );
                  }}
                  sx={{ mt: 1 }}
                />
              )}

              {/* Response Type */}
              <FormControl fullWidth sx={{ mt: 2 }}>
                <InputLabel id={`response-type-label-${index}`}>
                  Response Type
                </InputLabel>
                <Select
                  labelId={`response-type-label-${index}`}
                  value={endpoint.responseType}
                  label="Response Type"
                  onChange={(e) =>
                    setEndpoints((prev) =>
                      prev.map((ep, i) =>
                        i === index
                          ? { ...ep, responseType: e.target.value }
                          : ep
                      )
                    )
                  }
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 250,
                        width: 250,
                      },
                    },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    disablePortal: true, // ✅ keep menu near the component
                  }}
                >
                  <MenuItem value="application/json">application/json</MenuItem>
                  <MenuItem value="application/xml">
                    application/xml or text/xml
                  </MenuItem>
                  <MenuItem value="text/plain">text/plain</MenuItem>
                  <MenuItem value="text/html">text/html</MenuItem>
                  <MenuItem value="text/csv">text/csv</MenuItem>
                  <MenuItem value="application/x-yaml">
                    application/x-yaml or text/yaml
                  </MenuItem>
                  <MenuItem value="application/pdf">application/pdf</MenuItem>
                  <MenuItem value="image/jpeg">image/jpeg</MenuItem>
                  <MenuItem value="image/png">image/png</MenuItem>
                  <MenuItem value=" application/vnd.ms-excel">
                    {" "}
                    application/vnd.ms-excel
                  </MenuItem>
                  <MenuItem value="spreadsheet">
                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
                  </MenuItem>
                  <MenuItem value="application/msword">
                    application/msword
                  </MenuItem>
                  <MenuItem value="document">
                    application/vnd.openxmlformats-officedocument.wordprocessingml.document
                  </MenuItem>
                  <MenuItem value="application/zip">application/zip</MenuItem>
                  <MenuItem value="application/octet-stream">
                    application/octet-stream
                  </MenuItem>
                  <MenuItem value="multipart/form-data">
                    multipart/form-data
                  </MenuItem>
                  <MenuItem value="application/problem+json">
                    application/problem+json
                  </MenuItem>
                  <MenuItem value="application/problem+xml">
                    application/problem+xml
                  </MenuItem>
                </Select>
              </FormControl>
              {/* Custom Headers */}
              <Typography
                variant="subtitle1"
                fontWeight={"bold"}
                sx={{ mt: 2, mb: 1, fontSize: "14px" }}
              >
                Custom Headers
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    //sx={{ width: "230px" }}
                    fullWidth
                    label="Header Key"
                    placeholder="Enter Key"
                    value={headerKey}
                    onChange={(e) => setHeaderKey(e.target.value)}
                  />
                </FormControl>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    // sx={{ width: "210px" }}
                    fullWidth
                    label="Header Value"
                    placeholder="Enter Value"
                    value={headerValue}
                    onChange={(e) => setHeaderValue(e.target.value)}
                  />
                </FormControl>
                <IconButton
                  onClick={() => handleAddHeader(index)}
                  size="small"
                  sx={{ alignSelf: "flex-end", mb: 1 }}
                  disabled={
                    headerKey.trim() === "" || headerValue.trim() === ""
                  }
                >
                  <APIAddIcon />
                </IconButton>
              </Box>

              {/* Display Custom Headers */}
              {endpoint.headers && endpoint.headers.length > 0 && (
                <List>
                  {endpoint.headers.map((header, headerIndex) => (
                    <ListItem
                      key={headerIndex}
                      sx={{
                        bgcolor: "#f8f8f8",
                        borderRadius: 2,
                        my: 1,
                        px: 2,
                        py: 0.5,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={5}>
                          <Typography
                            variant="body1"
                            sx={{
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                              overflowWrap: "anywhere",
                            }}
                          >
                            {headerIndex + 1}. {header.key}
                          </Typography>
                        </Grid>
                        <Grid item xs={5}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "14px",
                              color: "#838383",
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                              overflowWrap: "anywhere",
                            }}
                          >
                            {header.value}
                          </Typography>
                        </Grid>
                        <Grid item xs={2} sx={{ textAlign: "right" }}>
                          <IconButton
                            onClick={() =>
                              handleDeleteHeader(headerIndex, index)
                            }
                            color="error"
                            disabled={header.isAuthHeader}
                          >
                            <RemoveCircleOutline />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </ListItem>
                  ))}
                </List>
              )}
              <Typography
                variant="subtitle1"
                fontWeight={"bold"}
                sx={{ mt: 2, mb: 1, fontSize: "14px" }}
              >
                Authorization
              </Typography>
              <FormControl fullWidth>
                <InputLabel>Authentication Method</InputLabel>
                <Select
                  value={endpoint.authMethod || "none"}
                  // onChange={(e) => {
                  //   setAuthMethod(e.target.value);
                  //   setEndpoints((prev) =>
                  //     prev.map((ep, i) =>
                  //       i === index ? { ...ep, authMethod: e.target.value } : ep
                  //     )
                  //   );
                  // }}
                  onChange={(e) => {
                    const selectedAuth = e.target.value;
                    setAuthMethod(selectedAuth);

                    setEndpoints((prev) =>
                      prev.map((ep, i) => {
                        if (i !== index) return ep;

                        let updated = { ...ep, authMethod: selectedAuth };

                        if (selectedAuth === "none") {
                          // Clear all auth-related fields
                          updated = {
                            ...updated,
                            bearerToken: "",
                            authUserName: "",
                            authPassword: "",
                            authKeyName: "",
                            authKeyValue: "",
                            authAddto: "",
                            auth2Flow: "",
                            authClientID: "",
                            authClientSecret: "",
                            authorizationURL: "",
                            tokenURL: "",
                            scope: "",
                            queryParams: ep.queryParams?.filter(p => !p.isAuthParam) || [],
                            headers: ep.headers?.filter(h => !h.isAuthHeader) || [],
                          };
                        }

                        return updated;
                      })
                    );
                  }}
                  label="Authentication Method"
                >
                  <MenuItem value="none">None</MenuItem>
                  <MenuItem value="Bearer Token">Bearer Token</MenuItem>
                  <MenuItem value="Basic Auth">Basic Auth</MenuItem>
                  <MenuItem value="API Key">API Key</MenuItem>
                  <MenuItem value="OAuth 2.0">OAuth 2.0</MenuItem>
                </Select>
              </FormControl>

              {/* {endpoint.authMethod === "none" && (
                authAddto === "none" 
               ) } */}

              {/* Bearer Token Auth */}
              {endpoint.authMethod === "Bearer Token" && (
                <Box mt={2} p={2} bgcolor="#49A3FF0F" borderRadius={2}>
                  <FormControl fullWidth>
                    <TextField
                      variant="outlined"
                      placeholder="Enter Bearer Token"
                      label="Bearer Token"
                      value={endpoint.bearerToken || ""}
                      onChange={(e) => {
                        setBearerToken(e.target.value);
                        setEndpoints((prev) =>
                          prev.map((ep, i) =>
                            i === index
                              ? { ...ep, bearerToken: e.target.value }
                              : ep
                          )
                        );
                      }}
                    />
                  </FormControl>
                </Box>
              )}

              {/* Basic Auth */}
              {endpoint.authMethod === "Basic Auth" && (
                <Box mt={2} p={2} bgcolor="#49A3FF0F" borderRadius={2}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Username"
                    placeholder="Enter User Name"
                    value={endpoint.authUserName || ""}
                    autoComplete="new-username"
                    onChange={(e) => {
                      setAuthUserName(e.target.value);
                      setEndpoints((prev) =>
                        prev.map((ep, i) =>
                          i === index
                            ? { ...ep, authUserName: e.target.value }
                            : ep
                        )
                      );
                    }}
                  />
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Password"
                    type="password"
                    sx={{ mt: 2 }}
                    placeholder="Enter Password"
                    autoComplete="new-password"
                    value={endpoint.authPassword || ""}
                    onChange={(e) => {
                      setAuthPassword(e.target.value);
                      setEndpoints((prev) =>
                        prev.map((ep, i) =>
                          i === index
                            ? { ...ep, authPassword: e.target.value }
                            : ep
                        )
                      );
                    }}
                  />
                </Box>
              )}

              {/* API Key Auth */}
              {endpoint.authMethod === "API Key" && (
                <Box mt={2} p={2} bgcolor="#49A3FF0F" borderRadius={2}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Name"
                    placeholder="Enter Key Name"
                    autoComplete="new-username"
                    value={endpoint.authKeyName || ""}
                    // onChange={(e) => {
                    //   setAuthKeyName(e.target.value);
                    //   setEndpoints((prev) =>
                    //     prev.map((ep, i) =>
                    //       i === index
                    //         ? { ...ep, authKeyName: e.target.value }
                    //         : ep
                    //     )
                    //   );
                    // }}
                    onChange={(e) => {
                      const newKeyName = e.target.value;
                      setAuthKeyName(newKeyName);
                      setEndpoints((prev) =>
                        prev.map((ep, i) =>
                          i === index
                            ? {
                              ...ep,
                              authKeyName: newKeyName,
                              // Update query params if authAddto is "query"
                              ...(ep.authAddto === "query" && {
                                queryParams: ep.queryParams?.map(param =>
                                  param.isAuthParam ? { ...param, key: newKeyName } : param
                                ) || []
                              }),
                              ...(ep.authAddto === "header" && {
                                headers: ep.headers?.map(header =>
                                  header.isAuthHeader ? { ...header, key: "Authorization" } : header
                                ) || []
                              })
                            }
                            : ep
                        )
                      );
                    }}

                  />
                  <TextField
                    fullWidth
                    variant="outlined"
                    type="password"
                    label="Value"
                    sx={{ mt: 2 }}
                    placeholder="Enter Key Value"
                    autoComplete="new-password"
                    value={endpoint.authKeyValue || ""}
                    // onChange={(e) => {
                    //   setAuthKeyValue(e.target.value);
                    //   setEndpoints((prev) =>
                    //     prev.map((ep, i) =>
                    //       i === index
                    //         ? { ...ep, authKeyValue: e.target.value }
                    //         : ep
                    //     )
                    //   );
                    // }}
                    onChange={(e) => {
                      const newKeyValue = e.target.value;
                      setAuthKeyValue(newKeyValue);
                      setEndpoints((prev) =>
                        prev.map((ep, i) =>
                          i === index
                            ? {
                              ...ep,
                              authKeyValue: newKeyValue,
                              // Update query params if authAddto is "query"
                              ...(ep.authAddto === "query" && {
                                queryParams: ep.queryParams?.map(param =>
                                  param.isAuthParam ? { ...param, value: newKeyValue } : param
                                ) || []
                              }),
                              ...(ep.authAddto === "header" && {
                                headers: ep.headers?.map(header =>
                                  header.isAuthHeader ? { ...header, value: `Bearer ${newKeyValue}` } : header
                                ) || []
                              })
                            }
                            : ep
                        )
                      );
                    }}
                  />
                  <FormControl fullWidth>
                    <InputLabel sx={{ mt: 2 }}>Add To</InputLabel>
                    <Select
                      value={endpoint.authAddto || "none"}
                      // onChange={(e) => {
                      //   setAuthAddto(e.target.value);
                      //   setEndpoints((prev) =>
                      //     prev.map((ep, i) =>
                      //       i === index
                      //         ? { ...ep, authAddto: e.target.value }
                      //         : ep
                      //     )
                      //   );
                      // }}
                      onChange={(e) => {
                        const newAddTo = e.target.value;
                        setAuthAddto(newAddTo);
                        setEndpoints((prev) =>
                          prev.map((ep, i) =>
                            i === index
                              ? {
                                ...ep,
                                authAddto: newAddTo,
                                // Handle query params based on selection
                                queryParams: (() => {
                                  const currentParams = ep.queryParams || [];

                                  if (newAddTo === "query") {
                                    // Add or update auth param in query params
                                    const existingAuthParamIndex = currentParams.findIndex(p => p.isAuthParam);

                                    if (existingAuthParamIndex >= 0) {
                                      // Update existing auth param
                                      return currentParams.map((param, idx) =>
                                        idx === existingAuthParamIndex
                                          ? { key: ep.authKeyName || "", value: ep.authKeyValue || "", isAuthParam: true }
                                          : param
                                      );
                                    } else {
                                      // Add new auth param
                                      return [
                                        ...currentParams,
                                        { key: ep.authKeyName || "", value: ep.authKeyValue || "", isAuthParam: true }
                                      ];
                                    }
                                  } else {
                                    // Remove auth param from query params
                                    return currentParams.filter(param => !param.isAuthParam);
                                  }
                                })(),

                                headers: (() => {
                                  const currentHeaders = ep.headers || [];

                                  if (newAddTo === "header") {
                                    // Add or update auth header
                                    const existingAuthHeaderIndex = currentHeaders.findIndex(h => h.isAuthHeader);

                                    if (existingAuthHeaderIndex >= 0) {
                                      // Update existing auth header
                                      return currentHeaders.map((header, idx) =>
                                        idx === existingAuthHeaderIndex
                                          ? { key: "Authorization", value: `Bearer ${ep.authKeyValue || ""}`, isAuthHeader: true }
                                          : header
                                      );
                                    } else {
                                      // Add new auth header
                                      return [
                                        ...currentHeaders,
                                        { key: "Authorization", value: `Bearer ${ep.authKeyValue || ""}`, isAuthHeader: true }
                                      ];
                                    }
                                  } else {
                                    // Remove auth header from headers
                                    return currentHeaders.filter(header => !header.isAuthHeader);
                                  }
                                })()
                              }
                              : ep
                          )
                        );
                      }}
                      label="Add to"
                      sx={{ mt: 2 }}
                    >
                      <MenuItem value="none">None</MenuItem>
                      <MenuItem value="query">Query Param</MenuItem>
                      <MenuItem value="header">Header</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              )}

              {/* OAuth 2.0 Auth */}
              {endpoint.authMethod === "OAuth 2.0" && (
                <Box mt={2} p={2} bgcolor="#49A3FF0F" borderRadius={2}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Token Name"
                    placeholder="Enter Token Name"
                    value={endpoint.auth2Flow || ""}
                    onChange={(e) => {
                      setAuth2Flow(e.target.value);
                      setEndpoints((prev) =>
                        prev.map((ep, i) =>
                          i === index
                            ? { ...ep, auth2Flow: e.target.value }
                            : ep
                        )
                      );
                    }}
                  />
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Client ID"
                    placeholder="Enter Client ID"
                    value={endpoint.authClientID || ""}
                    onChange={(e) => {
                      setAuthClientID(e.target.value);
                      setEndpoints((prev) =>
                        prev.map((ep, i) =>
                          i === index
                            ? { ...ep, authClientID: e.target.value }
                            : ep
                        )
                      );
                    }}
                    sx={{ mt: 2 }}
                  />
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Client Secret"
                    sx={{ mt: 2 }}
                    placeholder="Enter Client Secret"
                    value={endpoint.authClientSecret || ""}
                    onChange={(e) => {
                      setAuthClientSecret(e.target.value);
                      setEndpoints((prev) =>
                        prev.map((ep, i) =>
                          i === index
                            ? { ...ep, authClientSecret: e.target.value }
                            : ep
                        )
                      );
                    }}
                  />
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Authorization URL"
                    sx={{ mt: 2 }}
                    placeholder="Enter Authorization URL"
                    value={endpoint.authorizationURL || ""}
                    onChange={(e) => {
                      setAuthorizationURL(e.target.value);
                      setEndpoints((prev) =>
                        prev.map((ep, i) =>
                          i === index
                            ? { ...ep, authorizationURL: e.target.value }
                            : ep
                        )
                      );
                    }}
                  />
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Token URL"
                    sx={{ mt: 2 }}
                    placeholder="Enter Token URL"
                    value={endpoint.tokenURL || ""}
                    onChange={(e) => {
                      setTokenURL(e.target.value);
                      setEndpoints((prev) =>
                        prev.map((ep, i) =>
                          i === index ? { ...ep, tokenURL: e.target.value } : ep
                        )
                      );
                    }}
                  />
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Scope (Space-Separated)"
                    sx={{ mt: 2 }}
                    placeholder="Enter Scope"
                    value={endpoint.scope || ""}
                    onChange={(e) => {
                      setScope(e.target.value);
                      setEndpoints((prev) =>
                        prev.map((ep, i) =>
                          i === index ? { ...ep, scope: e.target.value } : ep
                        )
                      );
                    }}
                  />
                </Box>
              )}
            </Box>
          ))}
          <Button
            startIcon={<AddIcon />}
            onClick={addEndpoint}
            sx={{ mb: 1, mt: 2, fontSize: 12, color: "#49A3FF" }}
          >
            Add Endpoint
          </Button>
        </Box>
      )}
      {apiType === "soap" && (
        <Box sx={{ p: 2 }}>
          <Typography
            variant="subtitle1"
            fontWeight={"bold"}
            sx={{ fontSize: "" }}
          >
            Soap Configuration
          </Typography>
          <Typography fontSize={11}>
            Configure your SOAP API setting. SOAP APIs use XML for message
            format and typically require a WSDL document.
          </Typography>

          <Box
            sx={{
              p: 3,
              border: "1px",
              borderRadius: 2,
              backgroundColor: "#49A3FF0F",
              mt: 2,
            }}
          >
            <TextField
              fullWidth
              label="WSDL URL"
              placeholder="Enter WSDL URL"
              value={WSDLUrl}
              onChange={(e) => setWSDLUrl(e.target.value)}
            />
            <TextField
              fullWidth
              placeholder="Enter SOAP Action"
              label="SOAP Action"
              value={soapAction}
              onChange={(e) => setSoapAction(e.target.value)}
              sx={{ mb: 2, mt: 2 }}
              helperText="The SOAP action header identifies the intent of the SOAP request"
            />

            <Typography variant="subtitle1" sx={{ mt: 1, fontSize: "" }}>
              SOAP Version
            </Typography>
            <FormControl>
              <RadioGroup
                row
                value={soapVersion}
                onChange={(e) => setSoapVersion(e.target.value)}
              >
                <FormControlLabel
                  value="SOAP 1.1"
                  control={<Radio />}
                  label="SOAP 1.1"
                  sx={{ "& .MuiTypography-root": { fontSize: "0.850rem" } }}
                />
                <FormControlLabel
                  value="SOAP 1.2"
                  control={<Radio />}
                  label="SOAP 1.2"
                  sx={{ "& .MuiTypography-root": { fontSize: "0.850rem" } }}
                />
              </RadioGroup>
            </FormControl>
            <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
              <Typography
                variant="subtitle1"
                sx={{ flexGrow: 1, fontSize: "" }}
              >
                SOAP Envelope Template
              </Typography>
              <Button
                startIcon={<GenerateSampleIcon />}
                sx={{ textTransform: "none", color: "#49A3FF" }}
              >
                Generate Sample
              </Button>
            </Box>

            {/* Response Type */}
            <TextField
              fullWidth
              multiline
              minRows={3}
              // label="SOAP Envelope Template"
              placeholder="Enter Response Type"
              value={envelopeTemplate}
              onChange={(e) => setEnvelopeTemplate(e.target.value)}
              sx={{ mt: 0.6 }}
              helperText="The SOAP envelope contains the message structure with header and body elements"
            />
          </Box>
        </Box>
      )}
      {apiType === "graphql" && (
        <Box sx={{ p: 2 }}>
          <Typography
            variant="subtitle1"
            fontWeight={"bold"}
            sx={{ fontSize: "" }}
          >
            GraphQL Schema
          </Typography>
          <Typography fontSize={11}>
            Define your GraphQL schema. GraphQL uses a type system to define the
            structure of your API.
          </Typography>

          <Box
            sx={{
              p: 3,
              border: "1px",
              borderRadius: 2,
              backgroundColor: "#49A3FF0F",
              mt: 2,
            }}
          >
            <TextField
              fullWidth
              label="GraphQL Endpoint"
              placeholder="Enter GraphQL Endpoint"
              value={graphqlEndpoint}
              onChange={(e) => setGraphqlEndpoint(e.target.value)}
            />

            <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
              <Typography
                variant="subtitle1"
                sx={{ flexGrow: 1, fontSize: "" }}
              >
                GraphQL Schema
              </Typography>
              <Button
                startIcon={<GenerateSampleIcon />}
                sx={{ textTransform: "none", color: "#49A3FF" }}
              >
                Generate Sample
              </Button>
            </Box>

            {/* Response Type */}
            <TextField
              fullWidth
              multiline
              minRows={3}
              // label="SOAP Envelope Template"
              placeholder="Enter Response Type"
              value={graphqlResponseType}
              onChange={(e) => setGraphqlResponseType(e.target.value)}
              sx={{ mt: 0.6 }}
              helperText="Define your GraphQL types, queries, mutations, and subscriptions"
            />

            <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
              <Typography
                variant="subtitle1"
                sx={{ flexGrow: 1, fontSize: "" }}
              >
                Sample Query
              </Typography>
              <Button
                startIcon={<GenerateSampleIcon />}
                sx={{ textTransform: "none", color: "#49A3FF" }}
              >
                Generate Sample
              </Button>
            </Box>

            {/* Response Type */}
            <TextField
              fullWidth
              multiline
              minRows={3}
              // label="SOAP Envelope Template"
              placeholder="Enter your Query"
              value={sampleQuery}
              onChange={(e) => setSampleQuery(e.target.value)}
              sx={{ mt: 0.6 }}
            />
          </Box>
        </Box>
      )}
      <Box>
        {/* <Typography
          variant="subtitle1"
          fontWeight={"bold"}
          sx={{ mt: 1, fontSize: "" }}
        >
          Advanced Settings
        </Typography>
        <Box display="flex" gap={2} mt={1.4}>
          <TextField
            label="Request Timeout (ms)"
            placeholder="Enter Time"
            value={requestTimeout}
            onChange={(e) => setRequestTimeout(e.target.value)}
            fullWidth
          />
          <TextField
            label="Max Redirects"
            value={maxRedirects}
            placeholder="Enter Value"
            type="number"
            onChange={(e) => setMaxRedirects(e.target.value)}
            fullWidth
          />
        </Box>

        <Box display="flex" alignItems="center" mt={1} mb={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={followRedirects}
                onChange={() => setFollowRedirects(!followRedirects)}
              />
            }
            label="Follow Redirects"
            sx={{ "& .MuiTypography-root": { fontSize: "14px" } }} // Adjust font size here
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={verifySSL}
                onChange={() => setVerifySSL(!verifySSL)}
              />
            }
            label="Verify SSL Certificates"
            sx={{ "& .MuiTypography-root": { fontSize: "14px" } }} // Adjust font size here
          />
        </Box> */}
        <Box sx={{ p: 2, borderRadius: 2, mb: 3, bgcolor: "#FAFAFA" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mr: 3,
            }}
          >
            <Typography
              variant="subtitle1"
              fontWeight={"bold"}
              sx={{ fontSize: "" }}
            >
              Generate API Document
            </Typography>
            <Box sx={{ display: "flex", gap: 5 }}>
              <Button
                variant="outlined"
                sx={{ textTransform: "none", minWidth: "50px", mr: -3 }}
                onClick={generateAPIDocumentation}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <GenerateDocumentIcon width={15} height={15} />
                  <Typography sx={{ fontSize: "", color: "#49A3FF" }}>
                    Generate
                  </Typography>
                </Box>
              </Button>
              <Button
                variant="outlined"
                sx={{ textTransform: "none", minWidth: "50px", mr: -3 }}
                // onClick={handleTestConnection}
                onClick={() => handleDownloadAPIDocument(apiDocument)}
                disabled={!apiDocument}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <DownloadIcon width={15} height={15} />
                  <Typography sx={{ fontSize: "", color: "#49A3FF" }}>
                    Download
                  </Typography>
                </Box>
              </Button>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 2,
            mb: 0,
          }}
          borderTop={"1px solid #C6C6C6"}
          padding={2}
        >
          <Button
            startIcon={<APIResetFormIcon />}
            sx={{ color: "#49A3FF", textTransform: "none" }}
            onClick={handleResetForm}
          >
            Reset Form
          </Button>

          <Button
            variant="contained"
            color="#49A3FF"
            //  startIcon={<GenerateButtonIcon />}
            sx={{
              textTransform: "none",
              backgroundColor: "#49A3FF",
              color: "white",
            }}
            onClick={generateTestCases}
            disabled={!apiDocument}
          >
            Generate Test Cases
          </Button>
        </Box>
      </Box>
      <APIDocPopup open={successPopup} handleClose={handleCloseSuccessPopup} />
      <MessagePopup
        modalOpen={popupOpen}
        message={popupMessage}
        okayHandler={() => setPopupOpen(false)}
      />
    </Box>
  );
};

export default ManualDetails;
